var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHappyPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 15.2H36.5814C25.4295 15.2 16.3532 24.2763 16.3532 35.4282V63.5718C16.3532 74.7237 25.4295 83.8 36.5814 83.8H64.725C75.8769 83.8 84.9532 74.7237 84.9532 63.5718V35.4282C84.9532 24.2763 75.8769 15.2 64.725 15.2ZM21.6301 63.5718V35.4282C21.6301 27.1962 28.3494 20.4769 36.5814 20.4769H64.725C72.957 20.4769 79.6763 27.1962 79.6763 35.4282V50.3795H75.1733C67.5394 50.3795 60.7497 54.0382 56.4226 59.702C53.5731 60.863 51.1457 60.9333 50.6532 60.9333C43.3711 60.9333 39.1495 55.5509 38.6922 54.9528C37.8127 53.7919 36.1593 53.5456 34.9983 54.4251C33.8374 55.3046 33.5912 56.958 34.4706 58.119C35.4909 59.4558 41.014 66.2103 50.6532 66.2103C51.0402 66.2103 51.8493 66.2103 52.9399 66.0344C52.0252 68.5321 51.5327 71.2057 51.5327 74.0201V78.5231H36.5814C28.3494 78.5231 21.6301 71.8038 21.6301 63.5718ZM64.725 78.5231H56.8096V74.0201C56.8096 63.8884 65.0416 55.6564 75.1733 55.6564H79.6763V63.5718C79.6763 71.8038 72.957 78.5231 64.725 78.5231Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6172 45.1026C45.0596 45.1026 46.2557 43.9065 46.2557 42.4641V38.9462C46.2557 37.5038 45.0596 36.3077 43.6172 36.3077C42.1749 36.3077 40.9788 37.5038 40.9788 38.9462V42.4641C40.9788 43.9065 42.1749 45.1026 43.6172 45.1026Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6892 45.1026C59.1316 45.1026 60.3277 43.9065 60.3277 42.4641V38.9462C60.3277 37.5038 59.1316 36.3077 57.6892 36.3077C56.2468 36.3077 55.0507 37.5038 55.0507 38.9462V42.4641C55.0507 43.9065 56.2468 45.1026 57.6892 45.1026Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyPost);
export default __webpack_public_path__ + "static/media/happyPost.2319a1e9.svg";
export { ForwardRef as ReactComponent };